export default __webpack_public_path__ + "static/media/boating.af61d421.png";